const { default: CreateQuestion } = require("../../components/question/CreateQuestion")

const CreateQuestionPage = () => {
    return(
        <div>
            
            <CreateQuestion />
        </div>
    )
}

export default CreateQuestionPage